import * as React from "react";
import { Alert } from "antd";
import { ObjectServiceExt } from "src/businessServices/businessServises.types";
import { EntityCardDataExt } from "src/pages/EntityCardPage/EntityCardStore";
import { Bom2aControl } from "./Bom2aControl";

interface PropsBom2aView {
  info: ObjectServiceExt;
  entityData: EntityCardDataExt;
}

export const Bom2aView: React.FC<PropsBom2aView> = ({ info, entityData }) => {
  const { id: objectServiceId } = info;
  const { entity, object } = entityData;
  if (!entity)
    return <Alert type="error" message="Отсутствуют данные экземпляра" />;
  return (
    <Bom2aControl
      objectServiceId={objectServiceId}
      entityId={entity.id}
      modelObjectId={object.id}
    />
  );
};
